import { ICoreIds } from '@/Model/model';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import GlobalMutationNames from '@/store/global/mutationNames';

const { SUPRESS_GLOBAL_ERROR_POPUP } = GlobalMutationNames;

@Module({ namespaced: true, name: 'globalModule' })
export class GlobalModule extends VuexModule {
  sites: Array<Object> = [];
  coreIds: ICoreIds[] = [
    { id: 0, programId: 0, siteId: 0, roleId: 0, accountId: 0 },
  ];

  supressGlobalErrorPopup = false;

  ldClient: any = null;

  get storedLDClient() {
    return this.ldClient;
  }

  get getUpdatedSites() {
    return this.sites;
  }

  get getCoreIds() {
    return this.coreIds;
  }

  @Mutation
  mutateLDClient(ldClient: any) {
    this.ldClient = ldClient;
  }

  @Mutation
  [SUPRESS_GLOBAL_ERROR_POPUP](supressGlobalErrorPopup: boolean) {
    this.supressGlobalErrorPopup = supressGlobalErrorPopup;
  }

  @Mutation
  sitesUpdatedInfo(sites: Array<Object>) {
    this.sites = sites;
  }

  @Action({ commit: 'sitesUpdatedInfo' })
  showUpdatedSites(sites: Array<Object>) {
    return sites;
  }

  @Mutation
  mutateCoreIds(data: ICoreIds[]) {
    this.coreIds = data;
  }

  @Action({ commit: 'mutateCoreIds' })
  storeCoreIds(coreIds: ICoreIds[]) {
    return coreIds;
  }
}
